// Bilingual copy for the site. Georgian (ka) is the default language;
// English (en) is the toggle. Use with useLanguage()'s t() helper:
// t(nav.main), t(landing.title), etc.

export const nav = {
  main: { ka: "მთავარი", en: "Main" },
  blog: { ka: "ბლოგი", en: "Blog" },
  submission: { ka: "მონაწილეობა", en: "Submission" },
  gallery: { ka: "გალერეა", en: "Gallery" },
  about: { ka: "ჩვენ შესახებ", en: "About Us" },
  team: { ka: "გუნდი", en: "Our Team" },
  contact: { ka: "კონტაქტი", en: "Contact" },
  menu: { ka: "მენიუ", en: "Menu" },
};

export const footer = {
  est: { ka: "დაარსდა 2022 წელს, შუახევში", en: "Est. 2022, Shuakhevi" },
  backHome: { ka: "მთავარ გვერდზე →", en: "Back to homepage →" },
};

export const landing = {
  eyebrow: {
    ka: "საერთაშორისო ახალგაზრდული სმარტფონ-ფილმის ფესტივალი",
    en: "International Youth Smart-Film Festival",
  },
  titleLine1: { ka: "მთიდან", en: "Worldwide Smart-Voices" },
  titleLine2: { ka: "ზღვამდე", en: "in the Heart of Adjara" },
  lede: {
    ka: "Adjarian Film Tales — ახალგაზრდა რეჟისორები აჭარის მასშტაბით ხელში იღებენ ტელეფონს და იღებენ იმ მხარეს, რომელსაც იცნობენ: მთის სოფლებს, საზღვაო ქალაქებს და ყველაფერს მათ შორის. ნებისმიერი სმარტფონი. ნებისმიერი ჟანრი. მაქსიმუმ თხუთმეტი წუთი.",
    en: "Adjarian Film Tales — young filmmakers from around the globe pick up their phones to tell unique stories. From distant continents to local mountain villages, their visions come together in Shuakhevi for three unforgettable days of diverse screenings and events. Any smartphone. Any genre. Fifteen minutes or less.",
  },
  ctaSubmit: { ka: "გააგზავნე ფილმი — 2026 →", en: "Submit a Film — 2026 →" },
  ctaStory: { ka: "წაიკითხე ფესტივალის ისტორია ↓", en: "Read the festival's story ↓" },
  reelTags: [
    { ka: "სმარტ-ფილმი", en: "SMART-FILM" },
    { ka: "გადაღების ადგილზე", en: "ON LOCATION" },
    { ka: "კულისებში", en: "BEHIND THE SCENES" },
    { ka: "ფესტივალი 2023", en: "FESTIVAL 2023" },
    { ka: "ახალგაზრდა რეჟისორი", en: "YOUNG DIRECTOR" },
    { ka: "გახსნის საღამო", en: "OPENING NIGHT" },
    { ka: "დაჯილდოება", en: "AWARD CEREMONY" },
    { ka: "სემინარი", en: "WORKSHOP" },
    { ka: "აუდიტორია", en: "AUDIENCE" },
    { ka: "ჩვენება", en: "SCREENING" },
    { ka: "დახურვის საღამო", en: "CLOSING NIGHT" },
    { ka: "გუნდის ფოტო", en: "TEAM PHOTO" },
  ],
  statAgeValue: { ka: "13–29", en: "13–29" },
  statAge: { ka: "რეჟისორთა ასაკი", en: "filmmaker ages" },
  statCountriesValue: { ka: "15+", en: "15+" },
  statCountries: { ka: "წარმოდგენილი ქვეყანა", en: "countries represented" },
  statFilmsValue: { ka: "250+", en: "250+" },
  statFilms: { ka: "წარმოდგენილი ფილმი", en: "films presented" },
  statLengthValue: { ka: "≤15წთ", en: "≤15min" },
  statLength: { ka: "ფილმზე, ნებისმიერი ჟანრი", en: "per film, any genre" },
  statEst: { ka: "შუახევი, აჭარა", en: "Shuakhevi, Adjara" },
  estBadge: { ka: "დაარსდა 2022", en: "Est. 2022" },
  recapKicker: { ka: "2024 რეკაპი", en: "2024 Recap" },
  recapTitle: { ka: "გასული წელი, ერთ წუთზე ნაკლებში.", en: "Last year, in under a minute." },
  recapCaption: {
    ka: "Adjarian Film Tales, 2024 რეკაპი — 1:03",
    en: "Adjarian Film Tales, 2024 recap — 1:03",
  },
  recapFallback: {
    ka: "თქვენი ბრაუზერი ვიდეოს ჩვენებას ვერ უჭერს მხარს. შეგიძლიათ",
    en: "Your browser doesn't support embedded video. You can",
  },
  recapFallbackLink: { ka: "ჩამოტვირთოთ რეკაპი", en: "download the recap" },
  recapFallbackEnd: { ka: "სანაცვლოდ.", en: "instead." },
  regionKicker: { ka: "რეგიონი", en: "The Region" },
  regionTitle: { ka: "ხმების გაძლიერება კინოს მეშვეობით.", en: "Empowering Voices Through Cinema." },
  regionP1: {
    ka: "საერთაშორისო სმარტ-ფილმის ფესტივალის აჭარის მთიან რეგიონში ჩატარება მხოლოდ კულტურული ღონისძიების ორგანიზებაზე მეტია — ეს არის მნიშვნელოვანი ნაბიჯი ხელოვნების დეცენტრალიზაციისა და კინოს პოპულარიზაციისკენ იქ, სადაც შესაძლებლობები ტრადიციულად შეზღუდულია. უბრალო სმარტფონის პროფესიულ შემოქმედებით ინსტრუმენტად ქცევით, ფესტივალი არღვევს გეოგრაფიულ ბარიერებს და ახალგაზრდა ნიჭიერებებს აძლევს მძლავრ პლატფორმას, რომ გამოხატონ თავიანთი უნიკალური ხედვა.",
    en: "Bringing an international smart-film festival to the highlands of Adjara is more than just organizing a cultural event; it is a vital step toward decentralizing art and popularizing cinema where opportunities are traditionally limited. By turning a simple smartphone into a professional creative tool, the festival breaks geographical barriers and gives young talents a powerful platform to express their unique perspectives.",
  },
  regionP2: {
    ka: "ის ხელს უწყობს კულტურულ გაცვლას, აკავშირებს რა ადგილობრივ ტრადიციებს გლობალურ ნარატივებთან, ამასთანავე აძლიერებს რეგიონულ ტურიზმსა და კულტურულ ცნობიერებას. საბოლოო ჯამში, ეს ინიციატივა შუახევს ცოცხალ მხატვრულ ცენტრად აქცევს და ადასტურებს, რომ განსაკუთრებული კინემატოგრაფიული ისტორიები მსოფლიოს ნებისმიერი კუთხიდან შეიძლება წარმოიშვას.",
    en: "It fosters cultural exchange by connecting local traditions with global narratives, while boosting regional tourism and cultural awareness. Ultimately, this initiative transforms Shuakhevi into a vibrant artistic hub, proving that extraordinary cinematic stories can originate from any corner of the world.",
  },
  regionTag: { ka: "აჭარა", en: "ADJARA" },
  submitKicker: { ka: "როგორ მივიღოთ მონაწილეობა", en: "How to Participate" },
  submitTitle: { ka: "სამი ნაბიჯი, ერთი სმარტფონი.", en: "Three steps, one smartphone." },
  step1Title: { ka: "განბლოკვა", en: "Unlock" },
  step1Body: {
    ka: "ნებისმიერი სმარტფონი, ნებისმიერი ბრენდი — ეს არის ერთადერთი დაშვებული კამერა, ობიექტივიდან საბოლოო ექსპორტამდე.",
    en: "Any smartphone, any brand — that's the only camera allowed, from lens to final export.",
  },
  step2Title: { ka: "ჩაწერის დაწყება", en: "Press Record" },
  step2Body: {
    ka: "ნებისმიერი ჟანრი, მაქსიმუმ 15 წუთი. მონტაჟი ლეპტოპზეც შეგიძლიათ გააკეთოთ, მაგრამ ყველა კადრი ტელეფონით უნდა იყოს გადაღებული.",
    en: "Any genre, up to 15 minutes. Edit on a laptop if you like, but every shot is filmed on the phone.",
  },
  step3Title: { ka: "სმარტ-ფილმის შექმნა", en: "Create Smart-Film" },
  step3BodyPre: {
    ka: "მზა მაღალხარისხოვანი ფილმის ფაილი და ხელმოწერილი ავტორის ფორმა გამოგვიგზავნეთ",
    en: "Send the finished HQ movie file and the signed author form to",
  },
  step3BodyPost: {
    ka: "ორი ასაკობრივი კატეგორია: 13–19 და 20–29.",
    en: "Two age categories: 13–19 and 20–29.",
  },
  submitLink: { ka: "მონაწილეობის სრული წესები →", en: "Full submission guidelines →" },
  historyKicker: { ka: "ისტორია", en: "History" },
  historyTitle: {
    ka: "ადგილობრივი ჩვენებიდან საერთაშორისო სცენამდე.",
    en: "From a local screening to an international stage.",
  },
  y2022: {
    ka: "დაარსდა როგორც „აჭარული ამბები”, ჩატარდა ადგილობრივად, შუახევში. ფინალში 19 ფილმი გავიდა, ფესტივალს მხარი დაუჭირა აჭარის განათლების, კულტურისა და სპორტის სამინისტრომ.",
    en: "Founded as \"Adjarian News,\" held locally in Shuakhevi. 19 films reached the finale, backed by the Ministry of Education, Culture and Sport of Adjara.",
  },
  y2023: {
    ka: "საერთაშორისო გახდა სახელწოდებით Adjarian Film Tales — 19 ფინალისტი 6 ქვეყნიდან, განაცხადების რაოდენობა 300%-ით გაიზარდა.",
    en: "Went international as Adjarian Film Tales — 19 finalists from 6 countries, submissions up 300%.",
  },
  y2025: {
    ka: "8 ქვეყნის 35 ფილმი, საერთაშორისო ჟიური, სემინარები, მასტერკლასები და ექსკურსიები. ახალი თავი ჩვენს საფესტივალო თავგადასავალში.",
    en: "35 films from 8 countries, an international jury, workshops, masterclasses, and excursions. A new chapter in our festival's journey.",
  },
  y2026: {
    ka: "მეოთხე საფესტივალო გამოშვება ჩატარდება 2026 წლის 21-23 სექტემბერს. განაცხადების მიღება უკვე დაწყებულია. ველოდებით შენს სმარტ-ფილმს!",
    en: "The fourth festival edition will take place September 21–23, 2026. Submissions are already open. We're waiting for your smart-film!",
  },
  historyLink: { ka: "სრული ისტორია →", en: "Read the full history →" },
  experienceKicker: { ka: "გამოცდილება", en: "The Experience" },
  experienceTitle: {
    ka: "სამი დღე, რომელიც კარიერას აყალიბებს.",
    en: "Three days that shape careers.",
  },
  experienceP1: {
    ka: "შუახევის კულტურის ცენტრში გამართული სამი აქტივობებით სავსე დღის განმავლობაში, „აჭარული კინო ამბები“ გთავაზობთ მდიდარ და დინამიურ პროგრამას და კარიერის ჩამომყალიბებელ გამოცდილებას, რომელიც მობილურ კინემატოგრაფიას ყველა კუთხით აღნიშნავს.",
    en: "Over three action-packed days at the Shuakhevi Culture Center, \"Adjarian Film Tales\" offers a rich, dynamic program and an immersive, career-shaping experience that celebrates mobile cinema from every angle.",
  },
  experienceP2: {
    ka: "ფესტივალი მოიცავს დიდ ეკრანზე საკონკურსო ჩვენებებს, რეჟისორებთან ინტერაქტიულ კითხვა-პასუხის სესიებს და პრაქტიკულ მასტერკლასებს მობილურ განათებაზე, ფერთა კორექციასა და სმარტფონით კინემატოგრაფიაზე, რომლებსაც აღიარებული პროფესიონალი ოპერატორები უძღვებიან.",
    en: "The festival features big-screen competition screenings, interactive Q&A sessions with directors, and hands-on masterclasses on mobile lighting, color grading, and smartphone cinematography led by acclaimed professional cinematographers.",
  },
  experienceP3: {
    ka: "ტექნიკური სწავლის გარდა, მონაწილე რეჟისორები უშუალოდ ურთიერთობენ საერთაშორისო ჟიურის წევრებთან, იღებენ კონსტრუქციულ გამოხმაურებას და ამყარებენ კონტაქტებს მსოფლიოს სხვადასხვა კუთხიდან ჩამოსულ კოლეგებთან.",
    en: "Beyond technical learning, participating filmmakers engage directly with an international jury panel, receive constructive feedback, and network with fellow creators from around the world.",
  },
  experienceP4: {
    ka: "ღონისძიება ერთმანეთთან აახლოებს ადგილობრივ ტრადიციებსა და გლობალურ პერსპექტივებს კულტურული ექსკურსიებითა და ერთობლივი ვახშმებით აჭარის მთიან რეგიონში, რაც კულმინაციას აღწევს ოფიციალურ დაჯილდოების საზეიმო ცერემონიალზე — 18 ნომინაციური კატეგორიითა და ორი პრესტიჟული გრან-პრით, რაც ახალგაზრდა რეჟისორებს დარგობრივ აღიარებას, ეროვნულ მედია ხილვადობასა და ხანგრძლივ საერთაშორისო კავშირებს უტოვებს.",
    en: "The event seamlessly bridges local traditions with global perspectives through cultural excursions across the Adjarian highlands and networking dinners, culminating in a formal Grand Awards Ceremony honoring 18 nomination categories and two prestigious Grand Prix titles, ensuring young directors leave with industry recognition, national media visibility, and lasting international connections.",
  },
  experienceTag: { ka: "დაჯილდოება", en: "AWARDS" },
  footerFullContact: { ka: "სრული საკონტაქტო ინფორმაცია →", en: "Full contact details →" },
  footerReachUs: { ka: "დაგვიკავშირდით", en: "Reach Us" },
};

export const history = {
  eyebrow: { ka: "დაარსდა 2022, შუახევი", en: "Est. 2022, Shuakhevi" },
  title: { ka: "ფესტივალის ისტორია", en: "History of the Festival" },
  intro1: {
    ka: "თანამედროვე, მუდმივად განვითარებადი სმარტფონების რევოლუციური შესაძლებლობებით შთაგონებულებმა, 2022 წელს დავაარსეთ სმარტფონით გადაღებული ფილმების ფესტივალი, იმ იმედით, რომ გავაერთიანებდით ახალგაზრდებს, რომლებიც თავიანთ კინემატოგრაფიულ იდეებს უმარტივესი გაჯეტების მეშვეობით გამოხატავენ.",
    en: '2022 — The Spark: Inspired by the revolutionary potential of smartphones, the festival was founded in 2022 by journalist and poet Vakhtang Gograchadze under the initiative of NPO "Gadaskhvaperdi." ',
  },
  intro2: {
    ka: "ფესტივალი 2022 წელს დავაარსეთ. თავდაპირველად ის მხოლოდ ადგილობრივ დონეზე იმართებოდა და ადგილობრივ ნიჭიერებებზე იყო ორიენტირებული. სახელი უბრალოდ „აჭარული ამბები” იყო, რომელიც ძირითადად ჩვენი რეგიონის ბავშვებზე იყო გათვლილი. მან მაშინვე გაამართლა — მხარდაჭერა სხვა რეგიონებიდანაც მივიღეთ და მომდევნო წელს გაბედული ნაბიჯის გადადგმა და ფესტივალის საერთაშორისო დონეზე გატანა გადავწყვიტეთ.",
    en: 'Originally named "Adjarian Stories" (აჭარული ამბები), it began as a local one-day celebration focusing on local talents. Its immediate success—supported by the Ministry of Education, Culture and Sport of Adjara and the Shuakhevi Culture Center—proved that youth cinema had a powerful future',
  },
  intro3: {
    ka: "2023 წელს ფესტივალმა 15-ზე მეტი ქვეყნის ახალგაზრდები მიიზიდა, მათ შორის უკრაინის, ირანის, საფრანგეთისა და ინდოეთის წარმომადგენლები. განაცხადების რაოდენობა 300%-ით გაიზარდა, ხოლო მხარდაჭერა მივიღეთ ადგილობრივი და ეროვნული სპონსორებისა და მედიისგან.",
    en: "2023–2025 — Going International: Building on this momentum, we took a bold step to open our platform to the world. Subsequent editions attracted passionate youth from over 20 countries across 3 continents—including Japan, Ukraine, Iran, France, India, Mauritania, Senegal, and Egypt. ",
  },
  intro4: {
    ka: "2025 წელს კიდევ უფრო ფართოდ გავიშლებით — საერთაშორისო ჟიურის წევრებით და მეტი სემინარითა თუ მასტერკლასით. აიღეთ ტელეფონი, დააჭირეთ „ჩაწერას”, შექმენით თქვენი სმარტ-მაგია და გაგვიზიარეთ.",
    en: "Submissions surged, national media coverage expanded, and the festival featured iconic milestones like open-air screenings at the historic Khikhani Castle and visits to the cultural heritage of Chvana Valley. By 2025, the festival hosted prestigious international jury members, awarded two Grand Prix honors, and presented numerous specialized prizes.",
  },
  futureKicker: { ka: "მომავალი", en: "The Future" },
  futureTitle: {
    ka: "მომავალს გავხედოთ — 2026 და შემდეგ",
    en: "Looking Ahead — 2026 & Beyond",
  },
  futureLead: {
    ka: "თამამი გამოწვევების მიმართვა მსოფლიოსკენ.",
    en: "Taking Bold Challenges to the World.",
  },
  futureP1: {
    ka: "2026 წელს კიდევ უფრო მასშტაბურად ვგეგმავთ. ჩვენი მეოთხე გამოშვება უფრო ფართო საერთაშორისო ჟიურის შემადგენლობას, ჩამხუტავ მასტერკლასებსა და პრაქტიკულ სემინარებს შემოგვთავაზებს, რომლებიც მიზნად ისახავს 13–29 წლის შემოქმედთა გაძლიერებას. მზად ვართ ახალი გამოწვევებისთვის და მსოფლიო კინემატოგრაფიულ საზოგადოებას გავუზიაროთ ქართული სმარტ-ფილმის ფესტივალის ჩვენეული ხედვა.",
    en: "In 2026, we are aiming to go even broader. Our fourth edition will feature expanded international jury panels, immersive masterclasses, and hands-on workshops designed to empower creators aged 13–29. We are ready to embrace new challenges and share our original vision of the Georgian Smart-Film Festival with the global cinematic community.",
  },
  futureP2: {
    ka: "თუ გიყვართ კინო, გწამთ სმარტ-ტექნოლოგიების მზარდი შესაძლებლობების და იცით, რომ უბრალო ტელეფონს შეუძლია განსაკუთრებული ისტორია მოყვეს — ეს ფესტივალი თქვენთვისაა!",
    en: "If you love cinema, believe in the rising possibilities of smart-technology, and know that a simple phone can tell an extraordinary story - this festival is for you!",
  },
  yearByYearTitle: {
    ka: "სამი გამოშვება, ერთი ისტორია.",
    en: "Three editions, one story.",
  },
  y2022body: {
    ka: "პირველი ფესტივალი ადგილობრივად ჩატარდა. მას „აჭარული ამბები” ერქვა და ფინალში 19 ფილმი გავიდა. ფესტივალმა ყველა მოლოდინს გადააჭარბა და რეგიონში დიდი ყურადღება მიიპყრო, მოიგო აჭარის განათლების, კულტურისა და სპორტის სამინისტროს საგრანტო კონკურსი. მას შემდეგ ფესტივალს ადგილობრივი და ეროვნული სამინისტროებისა და ორგანიზაციების მხარდაჭერა აქვს. მთავარი ფინანსური მხარდამჭერია შუახევის მუნიციპალიტეტის მერია.",
    en: 'The first festival was held locally. It was called "Adjarian News" and there were 19 films in the finale. The festival exceeded all expectations and drew huge attention in the region, winning the grant competition of the Ministry of Education, Culture and Sport of Adjara. Since then, the festival has the support of local and national ministries and organizations. The main financial supporter is Shuakhevi City Hall.',
  },
  y2023body: {
    ka: "მეორე ფესტივალმა საერთაშორისო დონეზე გადადგა ნაბიჯი. ათობით ფილმს შორის ფინალში 19 ახალგაზრდა რეჟისორი გავიდა 6 ქვეყნიდან (საქართველო, უკრაინა, ირანი, იაპონია, საფრანგეთი, ინდოეთი). გამონაკლისის სახით ორივე გრან-პრი მხატვრულ ფილმებს ერგო. ფესტივალმა სხვა ქვეყნების ინტერესი დაიმსახურა და კვლავ მოიგო აჭარის განათლების, კულტურისა და სპორტის სამინისტროს საგრანტო კონკურსი.",
    en: "The second festival stepped up to an international level. Out of dozens of films, 19 young filmmakers from 6 countries made it into the finale (Georgia, Ukraine, Iran, Japan, France, India). Due to an exception, both Grand Prix awards went to fiction films. The festival started attracting interest from other countries and again won the grant competition of the Ministry of Education, Culture and Sport of Adjara.",
  },
  y2025body: {
    ka: "ეს წელი ფესტივალის ისტორიაში ნამდვილ გარდატეხის წერტილად იქცა. „აჭარულმა კინო ამბებმა“ არნახული მასშტაბები შეიძინა — გაზრდილი დაფინანსებით, გაფართოებული მხარდაჭერითა და უპრეცედენტო საერთაშორისო ჩართულობით. სწორედ ამ წელს ფესტივალს პირველად ეწვივნენ უცხოელი მონაწილეები და ჟიურის საერთაშორისო წევრები, რამაც პროექტი სრულიად ახალ კინემატოგრაფიულ სიმაღლეზე აიყვანა. პროგრამაში 8 ქვეყნის 35 საუკეთესო ფილმი შეირჩა. ეკრანზე გაცოცხლდა სრულიად განსხვავებული კულტურები და ისტორიები — უკრაინიდან, საფრანგეთიდან, სენეგალიდან, მავრიტანიიდან, კენიიდან, ირანიდან, ინდოეთიდან და, რა თქმა უნდა, მასპინძელი საქართველოდან.",
    en: 'This year marked a true turning point in the festival\'s history. "Adjarian Cinema Stories" expanded to unprecedented proportions—backed by increased funding, broader support, and unprecedented international engagement. It was in this very year that foreign participants and international jury members visited the festival for the first time, elevating the project to an entirely new cinematic height. The program selected the 35 best films from 8 countries. The silver screen brought to life remarkably diverse cultures and stories—from Ukraine, France, Senegal, Mauritania, Kenya, Iran, India, and, of course, the host nation of Georgia.',
  },
};

export const submission = {
  eyebrow: { ka: "მონაწილეობა — 2025", en: "Submissions — 2025" },
  title: { ka: "როგორ მივიღოთ მონაწილეობა", en: "How to Participate" },
  lede: {
    ka: "ნებისმიერი სმარტფონი. ნებისმიერი ჟანრი. მაქსიმუმ თხუთმეტი წუთი. აი, ყველაფერი, რაც უნდა იცოდეთ, სანამ ჩაწერას დაიწყებთ.",
    en: "Any smartphone. Any genre. Fifteen minutes or less. Here's everything you need to know before you hit record.",
  },
  step1Title: { ka: "განბლოკვა", en: "Unlock" },
  step1Body: {
    ka: "ფილმები მთლიანად სმარტფონით უნდა იყოს გადაღებული — ნებისმიერი ბრენდის. ეს არის ერთადერთი დაშვებული კამერა, ობიექტივიდან საბოლოო ექსპორტამდე.",
    en: "The films must be entirely made by smartphones — any brand. That's the only camera allowed, from lens to final export.",
  },
  step2Title: { ka: "ჩაწერის დაწყება", en: "Press Record" },
  step2Body: {
    ka: "მაქსიმუმ 15 წუთი, ნებისმიერი ჟანრი. დამოუკიდებელ რეჟისორებს, ახალგაზრდულ და სტუდენტურ კინოსტუდიებს შეუძლიათ გამოაგზავნონ სურვილისამებრ ბევრი ფილმი.",
    en: "Maximum 15 minutes, any genre. Independent filmmakers, Youth Film Studios and Student Film Studios may submit as many films as they like.",
  },
  step3Title: { ka: "სმარტ-ფილმის შექმნა", en: "Create Smart-Film" },
  step3Body: {
    ka: "მონტაჟი ლეპტოპზეც შეგიძლიათ გააკეთოთ — მთავარია, გადაღება მოხდეს სმარტფონით და არა ფოტო/ვიდეო კამერით.",
    en: "Edit on a laptop if you like — the main point is that it must be filmed on a smartphone, not a photo/video camera.",
  },
  ageTitle: { ka: "ასაკობრივი კატეგორიები", en: "Age categories" },
  ageBody: {
    ka: "13–29 წელი, ორ კატეგორიად დაყოფილი: თინეიჯერები (13–19) და სტუდენტები (20–29).",
    en: "13–29 years old, split into two categories: teens (13–19) and students (20–29).",
  },
  formTitle: { ka: "საკონკურსო ფორმა", en: "Application form" },
  formBodyPre: { ka: "მონაწილეებმა უნდა შეავსონ", en: "Applicants must fill out the" },
  formBodyLink: { ka: "Google ფორმა", en: "Google Form" },
  formBodyMid: {
    ka: "და გამოაგზავნონ, ხელმოწერილი, ფილმის HQ ვერსიასთან ერთად",
    en: "and send it, signed, along with an HQ version of the film to",
  },
  emailCta: { ka: "გამოაგზავნეთ თქვენი ნამუშევარი →", en: "Email your submission →" },
};

export const gallery = {
  eyebrow: { ka: "წინა გამოშვებებიდან", en: "From Past Editions" },
  title: { ka: "გალერეა", en: "Gallery" },
  lede: {
    ka: "წამები ფესტივალიდან — სცენაზე, კამერის უკან და დარბაზში.",
    en: "Moments from the festival — on stage, behind the camera, and in the audience.",
  },
  openImage: { ka: "სურათის გახსნა", en: "Open image" },
  close: { ka: "დახურვა", en: "Close" },
  prev: { ka: "წინა სურათი", en: "Previous image" },
  next: { ka: "შემდეგი სურათი", en: "Next image" },
  viewerLabel: { ka: "გალერეის სურათების მაყურებელი", en: "Gallery image viewer" },
  allYears: { ka: "ყველა", en: "All" },
  loading: { ka: "იტვირთება...", en: "Loading..." },
  winnersKicker: { ka: "გამარჯვებულები", en: "Winners" },
  winnersTitle: { ka: "გამარჯვებულთა ფოტოები", en: "Winners" },
};

export const about = {
  eyebrow: { ka: "ფესტივალის შესახებ", en: "About the Festival" },
  title: { ka: "კინო, ხელმისაწვდომი ყველასთვის.", en: "Cinema, democratized." },
  lede: {
    ka: "Adjarian Film Tales — ყოფილი CinePhone-Adjara — არის საერთაშორისო ახალგაზრდული სმარტფონ-ფილმის ფესტივალი, რომელიც შუახევის მთიან რეგიონში, აჭარაში, საქართველოში იმართება.",
    en: 'We are "Adjarian Film Tales", an International Youth Smart-Film Festival based in the picturesque mountainous region of Adjara, Georgia. We celebrate the rising and thriving "smart-possibilities" of the magical world of cinema, powered by smartphones and modern technology. We unite bold young storytellers from across the globe, proving that high-quality, impactful film art is now accessible to anyone with a story to tell.',
  },
  s1Kicker: { ka: "2022 წლიდან", en: "Since 2022" },
  s1Title: { ka: "სმარტფონი ხვდება კინოს.", en: "Smartphones, meet cinema." },
  s1P1: {
    ka: "ჩვენ ვზეიმობთ სმარტფონებითა და თანამედროვე ტექნოლოგიით შექმნილი კინოს მზარდ და აყვავებულ „სმარტ-შესაძლებლობებს”. მას შემდეგ, რაც წამყვანმა სმარტფონის კომპანიებმა ჩვენი ყოველდღიური თანამგზავრი გაჯეტები შემოგვთავაზეს, ეს რევოლუციური აღმოჩნდა თანამედროვე ხელოვნების — მათ შორის კინოს — შექმნის გზებისთვის.",
    en: "We celebrate the endless creative freedom of mobile filmmaking. Today's ever-advancing technology has revolutionized modern art: creating compelling cinema no longer requires massive budgets or heavy equipment. ",
  },
  s1P2: {
    ka: "ჩვენ ვნახეთ უთვალავი საოცარი ნამუშევარი როგორც მოყვარულების, ისე აღიარებული რეჟისორებისგან — გადაღებული არა დიდი და მძიმე კამერებით, არამედ „პატარა” სმარტფონებით, რომლებსაც თანამედროვე კაცობრიობა ყოველდღიურად ატარებს.",
    en: "From aspiring young creators to passionate storytellers, we show that anyone can bring extraordinary cinematographic ideas to life using the simplest gadget already in their pocket.",
  },
  s2Kicker: { ka: "რატომ სწორედ აქ", en: "Why Here" },
  s2Title: {
    ka: "მთიანი მხარე, ცნობადობისგან შორს.",
    en: "A Mountain Stage for Global Stories.",
  },
  s2P1: {
    ka: "შუახევი შორსაა აჭარის ადმინისტრაციული ცენტრისგან, სადაც თანამედროვე კულტურა ნაკლებადაა განვითარებული. ჩვენ ამ ფესტივალს იმისთვის ვმართავთ, რომ პოპულარული გავხადოთ სმარტ-კინო და ნიჭიერ ბავშვებს მივცეთ საშუალება, გამოხატონ თავი ყველაზე ხელმისაწვდომი ტექნოლოგიით — ჩვეულებრივი სმარტფონით.",
    en: "Shuakhevi, nestled in the scenic highlands of Adjara, serves as the heart of our festival. In high-mountain regions, access to cinema infrastructure, film education, and creative opportunities is often limited. We created this festival to popularize the art of cinema, bridging cultural gaps and decentralizing artistic expression.",
  },
  s2P2: {
    ka: "გვჯერა, რომ ხელოვნება და კინო უნივერსალური და დემოკრატიულია, და რომ ნებისმიერს შეუძლია საინტერესო ამბავი მოყვეს იმ ტელეფონით, რომელიც უკვე ჯიბეში უდევს.",
    en: "By utilizing the most accessible technology—a simple smartphone—we give young talents from both local mountain villages and around the world a powerful platform to express their vision, tell their stories, and showcase their abilities. Over three unforgettable days, this mountain town transforms into a vibrant global hub where diverse cultures and youth perspectives meet under the open sky.",
  },
  s3Kicker: { ka: "ფესტივალამდე", en: "Before the Festival" },
  s3Title: {
    ka: "ჩვენ საკლასო ოთახიდან ვიწყებთ.",
    en: "We start in the classroom.",
  },
  s3P1: {
    ka: "ფესტივალამდე ჩვენ სკოლებს ვსტუმრობთ, ვმართავთ საინფორმაციო ლექციებსა და შეხვედრებს და ვამზადებთ ბავშვებს იმისთვის, რაც წინ ელით. გვინდა, ავამაღლოთ კინოსა და ხელოვნების შესახებ ცნობიერება და ვაჩვენოთ, რისი გაკეთებაც შესაძლებელია ყველაზე მარტივი ტექნოლოგიური საშუალებითაც კი.",
    en: "Our mission goes far beyond the silver screen. Before every festival edition, our team travels across regions, visiting schools and youth centers to conduct interactive lectures, workshops, and informational sessions. We prepare young minds for what's ahead, raise awareness about media and film, and show them how to express critical social issues using accessible technology.",
  },
  s4Kicker: { ka: "მომავალს გავხედოთ", en: "Looking Ahead" },
  s4Title: {
    ka: "ახალი თავი ჩვენი მხარისთვის.",
    en: "A new chapter for our region.",
  },
  s4P1: {
    ka: "ჩვენ გზაზე ვართ, რომ ავაშენოთ ეს ახალი კინემატოგრაფიული თავი აჭარის ჩვენს პატარა, ლამაზ კუთხეში — და ჩვენი ღირებულებები და მიდგომა საერთაშორისო დონეზე გავიტანოთ, როგორც ქართული, ისე უცხოური სმარტ-ფილმების საფუძველზე.",
    en: "We're on a journey to build this new cinema-chapter in our small, beautiful part of Adjara — bringing our value and approach to an international level, based on both Georgian and foreign smart-films.",
  },
  cultureCenterKicker: { ka: "ჩვენი მასპინძელი", en: "Our Host" },
  cultureCenterTitle: {
    ka: "შუახევის კულტურის ცენტრი: ფესტივალის გული",
    en: "The Shuakhevi Culture Center: Heart of the Festival",
  },
  cultureCenterP1: {
    ka: "ამ საერთაშორისო ზეიმის გულში დგას შუახევის კულტურის ცენტრი — ჩვენი ერთგული მასპინძელი და ფინანსური მხარდამჭერი. აჭარის მაღალმთიან რეგიონში მდებარე ეს კულტურული ძეგლი ყოველ სექტემბერს სმარტ-კინოს ცოცხალ სასახლედ იქცევა. ის მეტია, ვიდრე უბრალო დარბაზი — ეს არის მხატვრული თავშესაფარი, სადაც მსოფლიოს სხვადასხვა კუთხიდან ახალგაზრდა რეჟისორები იკრიბებიან, დიდ ეკრანზე წარადგენენ თავიანთ ნამუშევრებს და მონაწილეობენ შთამაგონებელ კულტურულ დიალოგში. ცენტრის სითბო და სტუმართმოყვარეობა ყოველ ჩვენებას, სემინარსა და დაჯილდოების ცერემონიალს დაუვიწყარ გამოცდილებად აქცევს მონაწილეებისა და სტუმრებისთვის.",
    en: "At the center of this international celebration stands the Shuakhevi Culture Center — our dedicated host and financial supporter. Nestled in the heart of the Adjarian highlands, this cultural landmark transforms every September into a vibrant palace of smart-cinema. More than just a venue, it serves as an artistic haven where young filmmakers from across the globe gather, present their work on the big screen, and engage in inspiring cultural dialogue. The warmth and hospitality of the Center make every screening, workshop, and award ceremony an unforgettable experience for participants and guests alike.",
  },
  tagAdjara: { ka: "აჭარა", en: "ADJARA" },
  tagShuakhevi: { ka: "შუახევი", en: "SHUAKHEVI" },
  tagWorkshop: { ka: "სემინარი", en: "WORKSHOP" },
  tagFestival: { ka: "ფესტივალი", en: "FESTIVAL" },
  tagCultureCenter: { ka: "კულტურის ცენტრი", en: "CULTURE CENTER" },
  programKicker: { ka: "პროგრამა", en: "The Program" },
  programTitle: {
    ka: "მოსალოდნელი ღონისძიებები და პროგრამის მთავარი მომენტები",
    en: "Anticipated Events & Program Highlights",
  },
  programP1: {
    ka: "შუახევის კულტურის ცენტრში გამართული სამი აქტიური დღის განმავლობაში, „აჭარული კინო ამბები“ გთავაზობთ მდიდარ და დინამიურ პროგრამას, რომელიც მობილურ კინემატოგრაფიას ყველა კუთხით აღნიშნავს. ფესტივალი მოიცავს საკონკურსო და არასაკონკურსო სმარტ-ფილმების ყოვლისმომცველ ჩვენებებს, რაც ახალგაზრდა შემოქმედებს იშვიათ შესაძლებლობას აძლევს, ნახონ თავიანთი სმარტფონით გადაღებული ისტორიები პროფესიულ დიდ ეკრანზე. ჩვენებების პარალელურად, ღონისძიება მოიცავს პრაქტიკულ საგანმანათლებლო მასტერკლასებს, რომლებსაც აღიარებული პროფესიონალი ოპერატორები და დარგის ექსპერტები უძღვებიან — მობილური განათების ტექნიკებიდან და ფერთა კორექციიდან დაწყებული, მოწინავე მობილური კამერის მართვით დამთავრებული. დარბაზს მიღმა, პროგრამა მოიცავს რეჟისორებთან ინტერაქტიულ კითხვა-პასუხის სესიებს, დისკუსიებს ხელმისაწვდომი ტექნოლოგიების განვითარებაზე და განსაკუთრებულ კულტურული ჩართულობის პროგრამას, რომელიც აჭარის მთიანი მხარის მემკვიდრეობასა და თვალწარმტაც ლანდშაფტებს წარმოაჩენს, რაც კულმინაციას აღწევს ოფიციალურ დაჯილდოების საზეიმო ცერემონიალზე, სადაც აღინიშნება გამარჯვებულები 18 ნომინაციასა და ორ პრესტიჟულ გრან-პრიში.",
    en: "Over three action-packed days at the Shuakhevi Culture Center, \"Adjarian Film Tales\" offers a rich and dynamic program designed to celebrate mobile cinema from every angle. The festival features comprehensive screening sessions of selected competition and non-competition smart-films, giving young creators the rare opportunity to see their smartphone-shot stories projected on a professional big screen. Alongside the screenings, the event incorporates hands-on educational masterclasses led by acclaimed professional cinematographers and industry experts, covering everything from mobile lighting techniques and color grading to advanced mobile camera control. Beyond the auditorium, the program includes interactive Q&A sessions with directors, panel discussions on the evolution of accessible technology, and an extraordinary cultural immersion program showcasing the heritage and breathtaking landscapes of the Adjarian highlands, culminating in a formal Grand Awards Ceremony where winners across 18 nominations and two prestigious Grand Prix titles are celebrated.",
  },
  filmmakerExperienceKicker: { ka: "მონაწილეთათვის", en: "For Participants" },
  filmmakerExperienceTitle: {
    ka: "რეჟისორის გამოცდილება",
    en: "The Filmmaker Experience",
  },
  filmmakerExperienceP1: {
    ka: "მონაწილე რეჟისორებისთვის „აჭარული კინო ამბები“ გაცილებით მეტია, ვიდრე საკონკურსო ჩვენება — ეს არის კარიერის ჩამომყალიბებელი გამოცდილება, რომელიც აახლოებს ადგილობრივ ტრადიციებსა და გლობალურ პერსპექტივებს. შუახევში ჩამოსვლისთანავე, ახალგაზრდა რეჟისორები ხვდებიან თბილ და ერთობლივ შემოქმედებით სივრცეში, სადაც პირდაპირ შეუძლიათ ურთიერთობა საერთაშორისო ჟიურის წევრებთან, ურთიერთობის დამყარება მსოფლიოს სხვადასხვა კუთხიდან ჩამოსულ კოლეგებთან და მათი ნამუშევრების შესახებ ღირებული, კონსტრუქციული გამოხმაურების მიღება. მონაწილეები გრძნობენ თავიანთი ფილმების ვნებიან და მრავალფეროვან აუდიტორიასთან გაზიარების აღტკინებას, ამავდროულად იძენენ პრაქტიკულ უნარებს ექსპერტების მიერ წარმართულ სემინარებზე, რაც მათ ხელოვნებას აღრმავებს. აჭარის უნიკალურ სტუმართმოყვარეობასთან, ერთობლივ ვახშმებთან და ორგანიზებულ რეგიონულ ექსკურსიებთან ერთად, რეჟისორები საქართველოდან მიდიან არა მხოლოდ ეროვნული მედია ხილვადობითა და დარგობრივი აღიარებით, არამედ ხანგრძლივი საერთაშორისო კავშირებითა და ახალი შთაგონებით, მომავალი კინემატოგრაფიული პროექტებისთვის.",
    en: "For participating filmmakers, \"Adjarian Film Tales\" is far more than a competitive screening—it is an immersive, career-shaping experience that bridges local traditions with global perspectives. From the moment young directors arrive in Shuakhevi, they step into a warm and collaborative creative hub where they can directly engage with an international panel of jury members, network with fellow directors from around the world, and receive invaluable constructive feedback on their work. Participants experience the thrill of showcasing their films to a passionate, diverse audience while gaining practical skills during expert-led workshops that elevate their craft. Combined with the unique hospitality of Adjara, networking dinners, and guided regional excursions, filmmakers walk away not only with national media visibility and industry recognition, but also with lasting international connections and fresh inspiration for their future cinematic projects.",
  },
};

export const team = {
  eyebrow: { ka: "ადამიანები მის მიღმა", en: "The People Behind It" },
  title: { ka: "ჩვენი გუნდი", en: "Our Team" },
  lede: {
    ka: "ფესტივალი დააარსა ჟურნალისტმა და კინომოყვარულმა ვახო გოგრაჭაძემ, რომელმაც სული და გული ჩადო პროექტში, რათა სმარტ-კინო აჭარის ახალგაზრდობამდე მიეტანა.",
    en: "The festival was founded by journalist and film-aficionado Vakho Gograchadze, who put his heart and soul into the project to bring smart-cinema to the youth of Adjara.",
  },
  staffKicker: { ka: "თანამშრომლები", en: "Staff" },
  staffTitle: { ka: "ფესტივალის მართვა.", en: "Running the festival." },
  juryKicker: { ka: "ჟიური", en: "Jury" },
  juryTitle: { ka: "სმარტ-ფილმების შეფასება.", en: "Judging the smart-films." },
  juryMember: { ka: "ჟიურის წევრი", en: "Jury Member" },
  jury2022Edition: { ka: "2022-2023 წლების გამოშვება", en: "2022–2023 Editions" },
  jury2025Edition: { ka: "2025 გამოშვება", en: "2025 Edition" },
  staff: [
    {
      name: { ka: "ვახო გოგრაჭაძე", en: "Vakho Gograchadze" },
      role: { ka: "დირექტორი | დამფუძნებელი", en: "Director | Founder" },
    },
    {
      name: { ka: "ეთერ ფარჩუკიძე", en: "Eter Parchukidze" },
      role: {
        ka: "საზოგადოებასთან ურთიერთობა | საერთაშორისო ურთიერთობები",
        en: "PR | International Relations",
      },
    },
    {
      name: { ka: "არჩილ თავდგირიძე", en: "Archil Tavdgiridze" },
      role: { ka: "IT", en: "IT" },
    },
    {
      name: { ka: "გურანდა დოლიძე", en: "Guranda Dolidze" },
      role: { ka: "კოორდინატორი", en: "Coordinator" },
    },
    {
      name: { ka: "ენრი ვერულიძე", en: "Enri Verulidze" },
      role: { ka: "კოორდინატორი", en: "Coordinator" },
    },
    {
      name: { ka: "თამარ ფარჩუკიძე", en: "Tamar Parchukidze" },
      role: { ka: "სელექტორი, სოც-მედია", en: "Selector, Social Media" },
    },
    {
      name: { ka: "მაია დავითაძე", en: "Maia Davitadze" },
      role: { ka: "მენეჯერი", en: "Manager" },
    },
    {
      name: { ka: "მირიან ორაგველიძე", en: "Mirian Oragvelidze" },
      role: { ka: "კოორდინატორი", en: "Coordinator" },
    },
    {
      name: { ka: "რამაზ ხმალაძე", en: "Ramaz Khmaladze" },
      role: { ka: "კოორდინატორი", en: "Coordinator" },
    },
    {
      name: { ka: "რაულ ცინცაძე", en: "Raul Tsintsadze" },
      role: { ka: "კოორდინატორი", en: "Coordinator" },
    },
    {
      name: { ka: "საბა გოგრაჭაძე", en: "Saba Gograchadze" },
      role: { ka: "სელექტორი და ლოჯისტიკა", en: "Selector and Logistics" },
    },
  ],
  jury: [
    { name: { ka: "ნათია თავდგირიძე", en: "Natia Tavdgiridze" } },
    { name: { ka: "გრიშა ჩიგოგიძე", en: "Grisha Chigogidze" } },
    { name: { ka: "ნინო გელოვანი", en: "Nino Gelovani" } },
  ],
  jury2025: [
    {
      name: { ka: "ჯონ შეჰატა", en: "John Shehata" },
      role: { ka: "ეგვიპტე. რეჟისორი და VFX/SFX Artist", en: "Egypt. Director and VFX/SFX Artist" },
    },
    {
      name: { ka: "ნინო გელოვანი", en: "Nino Gelovani" },
      role: { ka: "რეჟისორი, პროდიუსერი და ჟურნალისტი", en: "Director, producer and journalist" },
    },
    {
      name: { ka: "ელიზბარ ცივნარიძე (ელდარ ქუჩუქი)", en: "Elizbar Tsivnaridze (Eldar Kuchuki)" },
      role: { ka: "პროდიუსერი, მენეჯერი", en: "Producer, manager" },
    },
    {
      name: { ka: "ნატალი მ. სტუარტ-ფოქსი", en: "Natalie M. Stewart-Fox" },
      role: {
        ka: "მენეჯერი, საერთაშორისო პროექტების პროდიუსერი",
        en: "Manager, international projects producer",
      },
    },
  ],
};

export const contact = {
  eyebrow: { ka: "დაგვიკავშირდით", en: "Get in Touch" },
  title: { ka: "კონტაქტი", en: "Contact" },
  lede: {
    ka: "კითხვები მონაწილეობის, პარტნიორობის ან თავად ფესტივალის შესახებ — დაგვიკავშირდით ნებისმიერი ამ საშუალებით.",
    en: "Questions about submissions, partnerships, or the festival itself — reach us any of these ways.",
  },
  visit: { ka: "მოგვინახულეთ", en: "Visit Us" },
  address: {
    ka: "შუახევის კულტურის ცენტრი, გოგებაშვილის ქ. #6, შუახევის მუნიციპალიტეტი, აჭარა, საქართველო",
    en: "Shuakhevi Culture Center, Gogebashvili Str #6, Shuakhevi Municipality, Adjara, Georgia",
  },
  email: { ka: "მოგვწერეთ", en: "Email Us" },
  call: { ka: "დაგვირეკეთ", en: "Call Us" },
  follow: { ka: "გამოგვყევით", en: "Follow" },
  mapTitle: {
    ka: "Adjarian Film Tales-ის მდებარეობა Google რუკაზე",
    en: "Adjarian Film Tales location on Google Maps",
  },
};

export const blog = {
  eyebrow: { ka: "ბლოგი", en: "Blog" },
  title: { ka: "ფესტივალის ისტორიები", en: "Festival Stories" },
  intro: {
    ka: "თითოეული გამოშვება, საკუთარი სიტყვებით — მიმოხილვები, გამარჯვებულები, ჟიურის წარდგენა და ყველაფერი დანარჩენი, რაც შუახევიდან ფართო სამყაროსკენ გზაზე მოხდა.",
    en: "Every edition, in its own words — recaps, winners, jury introductions, and everything else that happened along the way from Shuakhevi to the wider world.",
  },
  kicker: { ka: "ყველა გამოშვება", en: "All Editions" },
  sectionTitle: { ka: "ერთი ისტორია წელიწადში.", en: "One story per year." },
  readStory: { ka: "წაიკითხეთ ისტორია →", en: "Read the story →" },
  comingSoon: { ka: "მალე", en: "Coming Soon" },
  posts: [
    {
      year: "2023",
      kicker: { ka: "2023 გამოშვება", en: "2023 Edition" },
      title: {
        ka: "საერთაშორისო გახდა: 19 ფინალისტი, 6 ქვეყანა",
        en: "Going International: 19 Finalists, 6 Countries",
      },
      excerpt: {
        ka: "ფესტივალის მეორე გამოშვებამ საერთაშორისო სცენაზე გადადგა ნაბიჯი — ახალი ქვეყნები, განაცხადების 300%-იანი ზრდა და პირველად საერთაშორისო ჟიური.",
        en: "The festival's second edition stepped onto the world stage — new countries, a 300% jump in submissions, and an international jury for the first time.",
      },
      tags: { ka: "მიმოხილვა · გამარჯვებულები · ჟიური", en: "Recap · Winners · Jury" },
      upcoming: false,
    },
    {
      year: "2022",
      kicker: { ka: "2022 გამოშვება", en: "2022 Edition" },
      title: {
        ka: "როგორ გაჩნდა ჩვენი ფესტივალი",
        en: "How Adjarian Film Tales Began",
      },
      excerpt: {
        ka: "დაარსდა როგორც „აჭარული ამბები” და ჩატარდა ადგილობრივად შუახევში — პირველმა გამოშვებამ ეკრანამდე 19 ფინალისტი ფილმი და სამინისტროს გრანტი მოიტანა რეგიონს.",
        en: "Founded as \"Adjarian News\" and held locally in Shuakhevi, our first edition brought 19 finalist films to the screen and a ministry grant to the region.",
      },
      tags: { ka: "მიმოხილვა · საწყისები", en: "Recap · Origins" },
      upcoming: false,
    },
    {
      year: "2025",
      kicker: { ka: "2025 გამოშვება", en: "2025 Edition" },
      title: {
        ka: "შემდეგი ნაბიჯი: საერთაშორისო ჟიური და ახალი სემინარები",
        en: "What's Next: International Jury & New Workshops",
      },
      excerpt: {
        ka: "განაცხადების მიღება მალე დაიწყება. აი, რა იცვლება ჩვენს მესამე გამოშვებაში — უფრო ფართო ჟიური და მეტი მასტერკლასი ახალგაზრდა რეჟისორებისთვის.",
        en: "Submissions are opening soon. Here's what's changing for our third edition — a broader jury and more masterclasses for young filmmakers.",
      },
      tags: { ka: "მალე", en: "Preview" },
      upcoming: true,
    },
  ],
};

export const blogPosts = {
  "2022": {
    kicker: { ka: "2022 გამოშვება", en: "2022 Edition" },
    title: { ka: "როგორ გაჩნდა ჩვენი ფესტივალი", en: "How Adjarian Film Tales Began" },
    bylineName: { ka: "ეთერ ფარჩუკიძე", en: "Eter Parchukidze" },
    bylineRole: {
      ka: "საზოგადოებასთან ურთიერთობა | საერთაშორისო ურთიერთობები",
      en: "PR & International Relations",
    },
    paragraphs: [
      {
        ka: "თანამედროვე, მუდმივად განვითარებადი სმარტფონების შესაძლებლობებით შთაგონებულებმა, 2022 წელს დავაარსეთ სმარტფონით გადაღებული ფილმების ფესტივალი, იმ იმედით, რომ გავაერთიანებდით ახალგაზრდებს, რომლებიც თავიანთ იდეებს უმარტივესი გაჯეტების მეშვეობით გამოხატავენ.",
        en: "Inspired by the ever-advancing possibilities of smartphone filmmaking, we founded this festival in 2022 hoping to unite young people who express their ideas through the simplest gadgets they own.",
      },
      {
        ka: "პირველი გამოშვება ადგილობრივად ჩატარდა სახელით „აჭარული ამბები” და ძირითადად ჩვენი რეგიონის ბავშვებზე იყო გათვლილი. ფინალში 19 ფილმი გავიდა — გაცილებით მეტი და გაცილებით უკეთესი, ვიდრე ველოდით.",
        en: "The first edition was held locally, under the name \"Adjarian News,\" and was aimed mainly at kids from our own region. Nineteen films made it into the finale — far more, and far better, than we expected.",
      },
      {
        ka: "გამოხმაურება შუახევის ფარგლებს მაშინვე გასცდა. ფესტივალმა მოიგო აჭარის განათლების, კულტურისა და სპორტის სამინისტროს საგრანტო კონკურსი, ხოლო შუახევის მუნიციპალიტეტის მერია გახდა ჩვენი მთავარი ფინანსური მხარდამჭერი — ურთიერთობა, რომელიც დღემდე გრძელდება.",
        en: "The response reached beyond Shuakhevi almost immediately. The festival won a grant from the Ministry of Education, Culture and Sport of Adjara, and Shuakhevi City Hall became our main financial supporter — a relationship that continues to this day.",
      },
      {
        ka: "სწორედ ამ ადგილობრივმა წარმატებამ დაგვარწმუნა, გადაგვედგა შემდეგი, უფრო დიდი ნაბიჯი — რეგიონული ჩვენებიდან საერთაშორისო ფესტივალამდე.",
        en: "That local success is what convinced us to take the next, bigger step: turning a regional screening into an international festival.",
      },
    ],
    hasWinners: false,
    hasJury: false,
    hasGallery: false,
  },
  "2023": {
    kicker: { ka: "2023 გამოშვება", en: "2023 Edition" },
    title: {
      ka: "საერთაშორისო გახდა: 19 ფინალისტი, 6 ქვეყანა",
      en: "Going International: 19 Finalists, 6 Countries",
    },
    bylineName: { ka: "ეთერ ფარჩუკიძე", en: "Eter Parchukidze" },
    bylineRole: {
      ka: "საზოგადოებასთან ურთიერთობა | საერთაშორისო ურთიერთობები",
      en: "PR & International Relations",
    },
    paragraphs: [
      {
        ka: "მეორე გამოშვებამ საერთაშორისო სცენაზე გადადგა ნაბიჯი ახალი სახელით — Adjarian Film Tales. ათობით განაცხადს შორის ფინალში 19 ახალგაზრდა რეჟისორი გავიდა 6 ქვეყნიდან — საქართველოდან, უკრაინიდან, ირანიდან, იაპონიიდან, საფრანგეთიდან და ინდოეთიდან.",
        en: "Our second edition stepped onto the international stage under a new name: Adjarian Film Tales. Out of dozens of submissions, 19 young filmmakers made the finale — from Georgia, Ukraine, Iran, Japan, France, and India.",
      },
      {
        ka: "განაცხადების რაოდენობა წინა წელთან შედარებით 300%-ით გაიზარდა, ხოლო ფინალისტებისა და გამარჯვებულების შერჩევაში პირველად საერთაშორისო ჟიური დაგვეხმარა.",
        en: "Submissions grew by 300% compared to our first year, and for the first time we welcomed an international jury to help select the finalists and winners.",
      },
      {
        ka: "გამონაკლისის სახით, ორივე გრან-პრი ამ წელს მხატვრულ ფილმებს ერგო. ფესტივალის მზარდმა რეპუტაციამ ახალი ქვეყნების ინტერესი მოიპოვა და კვლავ მოიგო აჭარის განათლების, კულტურისა და სპორტის სამინისტროს საგრანტო კონკურსი.",
        en: "As an exception this year, both Grand Prix awards went to fiction films. The festival's growing reputation brought interest from new countries and, once again, the support of the Ministry of Education, Culture and Sport of Adjara.",
      },
    ],
    hasWinners: true,
    winnersTitle: {
      ka: "ორივე გრან-პრი ამ წელს მხატვრულ ფილმებს ერგო.",
      en: "Both Grand Prix awards went to fiction films this year.",
    },
    winnersNote: {
      ka: "კატეგორიების გამარჯვებულთა სახელები დაზუსტების პროცესშია — მალე დაემატება სრული სია.",
      en: "Category winner names are being finalized for publication — check back soon for the full list.",
    },
    winners: [
      {
        category: { ka: "გრან-პრი — თინეიჯერები (13–19)", en: "Grand Prix — Teens (13–19)" },
        name: { ka: "სახელი დაემატება", en: "add winner name" },
      },
      {
        category: { ka: "გრან-პრი — სტუდენტები (20–29)", en: "Grand Prix — Students (20–29)" },
        name: { ka: "სახელი დაემატება", en: "add winner name" },
      },
      {
        category: { ka: "მაყურებელთა არჩევანი", en: "Audience Choice" },
        name: { ka: "სახელი დაემატება", en: "add winner name" },
      },
    ],
    hasJury: true,
    juryTitle: { ka: "სმარტ-ფილმების შეფასება.", en: "Judging the smart-films." },
    jury: [
      { name: { ka: "ნათია თავდგირიძე", en: "Natia Tavdgiridze" } },
      { name: { ka: "გრიშა ჩიგოგიძე", en: "Grisha Chigogidze" } },
      { name: { ka: "ნინო გელოვანი", en: "Nino Gelovani" } },
    ],
    juryMemberLabel: { ka: "ჟიურის წევრი", en: "Jury Member" },
    hasGallery: true,
    galleryKicker: { ka: "ფესტივალიდან", en: "From the Festival" },
    galleryTitle: { ka: "რამდენიმე მომენტი.", en: "A few moments." },
  },
  "2025": {
    kicker: { ka: "2025 გამოშვება · მალე", en: "2025 Edition · Preview" },
    title: {
      ka: "შემდეგი ნაბიჯი: საერთაშორისო ჟიური და ახალი სემინარები",
      en: "What's Next: International Jury & New Workshops",
    },
    bylineName: { ka: "ვახო გოგრაჭაძე", en: "Vakho Gograchadze" },
    bylineRole: { ka: "დირექტორი | დამფუძნებელი", en: "Director & Founder" },
    paragraphs: [
      {
        ka: "მესამე გამოშვებისთვის კიდევ უფრო ფართოდ ვიშლებით — სრულად საერთაშორისო ჟიურით და ახალი სემინარებითა თუ მასტერკლასებით აჭარის ახალგაზრდა რეჟისორებისთვის.",
        en: "For our third edition, we're aiming to go broader still — a fully international jury, and new workshops and masterclasses for young filmmakers across Adjara.",
      },
      {
        ka: "განაცხადების მიღება მალე დაიწყება. ნებისმიერი სმარტფონი, ნებისმიერი ჟანრი, მაქსიმუმ თხუთმეტი წუთი — აიღეთ ტელეფონი, დააჭირეთ „ჩაწერას” და გაგვიზიარეთ თქვენი სმარტ-მაგია.",
        en: "Submissions are opening soon. Any smartphone, any genre, fifteen minutes or less — grab your phone, press record, and share your smart-magic with us.",
      },
    ],
    hasWinners: false,
    hasJury: false,
    hasGallery: false,
  },
};

export const blogPostUi = {
  allStories: { ka: "← ყველა ისტორია", en: "← All Stories" },
  submitFilm: { ka: "გააგზავნეთ ფილმი →", en: "Submit a Film →" },
  winnersKicker: { ka: "გამარჯვებულები", en: "Winners" },
  juryKicker: { ka: "ჟიური", en: "Jury" },
  watchRecap: { ka: "უყურეთ მიმოხილვას", en: "Watch the recap" },
};
